import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { GasStationBrandDetailPanel } from "@/components/gas-stations/GasStationBrandDetailPanel";
import { PageSkeleton } from "@/components/ui/PageSkeleton";
import { useGasStationBrand } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function GasStationBrandDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: brand, isLoading, error } = useGasStationBrand(id ?? "");

  if (isLoading) return <PageSkeleton />;

  if (error || !brand) {
    return (
      <motion.div
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3 }}
        className="space-y-4"
      >
        <Link
          to="/gas-stations"
          aria-label="Back to fuel network"
          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-accent)] text-white opacity-100 transition hover:bg-[var(--color-accent-hover)]"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <p className="text-sm text-muted">Gas station brand not found.</p>
      </motion.div>
    );
  }

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to="/gas-stations"
        aria-label="Back to fuel network"
        className="mb-5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-accent)] text-white opacity-100 transition hover:bg-[var(--color-accent-hover)]"
      >
        <ArrowLeft className="h-5 w-5" />
      </Link>
      <GasStationBrandDetailPanel brand={brand} />
    </motion.div>
  );
}
